

























































import { defineComponent, reactive, ref } from '@vue/composition-api'
import Layout from '../organisms/common/Layout.vue'

export default defineComponent({
  name: 'Login',
  components: { Layout },
  setup(props, context) {
    const model = reactive({
      code: '',
      password: '',
    })
    const loading = ref(false)
    const failed = ref(false)

    const codeRules = [(v: any) => !!v || 'ユーザーIDは必須項目です。']
    const passwordRules = [
      (v: any) => !!v || 'パスワードは必須項目です。',
      (v: any) =>
        (v && v.length <= 32) || 'パスワードは32文字以内で入力してください。',
    ]

    const login = async () => {
      loading.value = true
      try {
        await context.root.$store.dispatch('user/login', model)
        const route = context.root.$route
        context.root.$router.push({
          path:
            typeof route.query.backuri === 'string' ? route.query.backuri : '/',
        })
      } catch (error) {
        failed.value = true
        loading.value = false
      }
    }

    return {
      model,
      loading,
      codeRules,
      passwordRules,
      login,
      failed,
    }
  },
})
